<template>
  <div class="tabbarPage">
    <!-- <van-tabbar class="my-tabber" v-model="tabbarActive" active-color="#EB1B3D">
      <van-tabbar-item @click="handleNavBar(1)">首页</van-tabbar-item>
      <van-tabbar-item @click="handleNavBar(2)">消息</van-tabbar-item>
      <van-tabbar-item @click="handleNavBar(3)">我的</van-tabbar-item>
    </van-tabbar> -->
    <div class="my_tabbar flex-between">
      <div
        class="my_tabba_item"
        v-for="(item, index) in tabList"
        :key="index + 'a'"
        :class="{ active: tabbarActive == index }"
        @click="handleNavBar(index)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabbar",
  data() {
    return {
      tabList: ["业务", "订单列表", "订单投诉", "我的"],
      tabbarActive: 0,
      userInfo: "",
    };
  },
  created() {
    this.$watch(() => {
      if (this.$route.path == "/mine") {
        this.tabbarActive = 3;
      } else if (this.$route.path == "/home") {
        this.tabbarActive = 0;
      } else if (this.$route.path == "/orderList") {
        this.tabbarActive = 1;
      } else if (this.$route.path == "/orderComplain") {
        this.tabbarActive = 2;
      }
    });
  },
  methods: {
    handleNavBar(index) {
      if (this.$route.path == "/home" && index == 0) {
        this.tabbarActive = 0;
        return;
      }
      if (this.$route.path == "/orderList" && index == 1) {
        this.tabbarActive = 1;
        return;
      }
      if (this.$route.path == "/orderComplain" && index == 2) {
        this.tabbarActive = 2;
        return;
      }
      if (this.$route.path == "/mine" && index == 3) {
        this.tabbarActive = 3;
        return;
      }
      
      if (index == 0) {
        this.tabbarActive = index;
        this.$router.push("/home");
      } else if (index == 3) {
        this.tabbarActive = index;
        this.$router.push("/mine");
      } else if(index == 1) {
        this.tabbarActive = index;
        this.$router.push("/orderList");
      }else {
        this.tabbarActive = index;
        this.$router.push("/orderComplain");
      }
    },
  },
};
</script>

<style lang='less' scoped>
.tabbarPage {
  width: 750px;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 150px;
  font-size: 24px;
  color: #000000;
  border-top: 1px solid #c9c9c9;
  background: #fff;
  z-index: 1000001;
  .my_tabbar {
    height: 100%;
    .my_tabba_item {
      border-right: 1px solid #c9c9c9;
      text-align: center;
      height: 100%;
      line-height: 150px;
      flex: 1;
      &:last-child {
        border-right: none;
      }
      &.active {
        color: #eb1b3d;
      }
    }
  }
}
</style>